<div class="d-flex flex-row">
  <span class="text-cta h5 mb-0 fw-bold me-2">{{salonDetails.averageRating | number: '1.1-1'}}</span>
  <app-rating-stars [clickable]="false"
                    class="me-2"
                    [ratingValue]="salonDetails.averageRating"></app-rating-stars>
</div>
<a href="#"
   class="text-decoration-none"
   (click)="scrollToReviews('reviewsContainerId'); false"
   [translate]="'SALON-DETAILS.LINK-GO-TO-REVIEWS'"
   [translateParams]="{reviewsCount: salonDetails.reviewsCount}">
</a>
